<div class="card-skeleton">
    <div class="flex w-full h-full">
        <div class="skeleton cards" [ngClass]="['skeleton', 'cards', 'h-' + Altura]"></div>
    </div>
</div>